const HALF = 2;
const QUARTER = 4;

export const buildRectStroke = (width, height, stroke) => {
	const { width: strokeWidth, color: strokeColor } = stroke;
	const border = document.createElementNS("http://www.w3.org/2000/svg", "rect");
	const borderAttributes = {
		fill: "none",
		x: strokeWidth / HALF,
		y: strokeWidth / HALF,
		width: width - strokeWidth,
		height: height - strokeWidth,
		stroke: strokeColor,
		"stroke-width": strokeWidth,
		rx: strokeWidth / QUARTER,
	};
	Object.keys(borderAttributes).forEach((attribute) => {
		border.setAttribute(attribute, borderAttributes[attribute]);
	});
	return border;
};

export const buildCircleStroke = (width, height, stroke) => {
	const { width: strokeWidth, color: strokeColor } = stroke;
	const border = document.createElementNS("http://www.w3.org/2000/svg", "circle");
	const borderAttributes = {
		fill: "none",
		cx: height / HALF,
		cy: width / HALF,
		r: (width - strokeWidth) / HALF,
		stroke: strokeColor,
		"stroke-width": strokeWidth,
	};
	Object.keys(borderAttributes).forEach((attribute) => {
		border.setAttribute(attribute, borderAttributes[attribute]);
	});
	return border;
};
